<template>
  <div>
      <file-pond
        name="test"
        ref="pond"
        label-idle="<small><i>Arrastra tus archivos aquí...</i></small>"
        v-bind:allow-multiple="multiple"
        v-on:addfile="handleUpload"
        v-on:removefile="handleCancel"
      />
  </div>
</template>

<script>
// Import Vue FilePond
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";

// // Import image preview plugin styles
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";

// Import image preview and file type validation plugins
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileEncode from "filepond-plugin-file-encode";
import "filepond-plugin-image-edit/dist/filepond-plugin-image-edit.css";

// // Create component
const FilePond = vueFilePond(
  FilePondPluginImagePreview,
  FilePondPluginFileEncode,
);

export default {
  name: "DocUpload",
  methods: {
    handleUpload() {
        this.$emit("uploaded", this.$refs.pond.getFile().getFileEncodeDataURL(), this.$refs.pond.getFile().filename);
    },
    handleCancel() {
        this.$emit("onCancel");
    }
  },
  components: {
    FilePond,
  },
  props: {
      multiple: false,
  }
};
</script>
